(() => {
  if (customElements.get('sf-proof-stories')) return;
  customElements.define('sf-proof-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.yp-track');
      if (!track) return;
      const abort = new AbortController();
      const on = (target, event, handler, options = {}) => target.addEventListener(event, handler, {...options, signal: abort.signal});
      const previous = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const position = this.querySelector('[data-position]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const step = () => (track.firstElementChild?.getBoundingClientRect().width || 0) + (parseFloat(getComputedStyle(track).columnGap) || 0) || 1;
      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const index = Math.min(track.children.length - 1, Math.round(track.scrollLeft / step()));
        previous.disabled = max < 2 || track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= max - 2;
        position.textContent = `${Math.max(0, index + 1)} / ${track.children.length}`;
      };
      const move = direction => track.scrollBy({left: direction * step(), behavior: reduced.matches ? 'instant' : 'smooth'});
      on(previous, 'click', () => move(-1));
      on(next, 'click', () => move(1));
      on(track, 'scroll', update, {passive: true});
      on(track, 'keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      on(this, 'shopify:block:select', event => {
        const card = [...track.children].find(child => child.dataset.blockId === event.detail?.blockId || child === event.target);
        if (!card) return;
        track.scrollTo({left: card.offsetLeft - (track.firstElementChild?.offsetLeft || 0), behavior: 'instant'});
        update();
      });
      const resize = new ResizeObserver(update);
      resize.observe(track);
      update();

      const films = [];
      for (const card of this.querySelectorAll('[data-yn-film]')) {
      const video = card.querySelector('video');
      const button = card.querySelector('[data-film-toggle]');
      if (!video || !button) continue;
      let visible = false;
      let userPaused = false;
      const updateFilm = () => {
        card.dataset.playing = String(!video.paused);
        button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      };
      const start = async () => {
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        else if (video.error) video.load();
        try {
          await video.play();
          if (!visible || document.hidden || abort.signal.aborted) video.pause();
        } catch { /* The poster and play control remain usable when autoplay is blocked. */ }
        updateFilm();
      };
      const auto = () => {
        if (card.dataset.autoplay !== 'false' && visible && !document.hidden && !reduced.matches && !userPaused) start();
        else video.pause();
      };
      on(button, 'click', () => {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else start();
      });
      for (const event of ['play', 'pause', 'error']) on(video, event, updateFilm);
      const intersection = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
        auto();
      }, {threshold: [0, .35]});
      intersection.observe(card);
      on(document, 'visibilitychange', auto);
      on(reduced, 'change', auto);
      updateFilm();
      films.push({intersection, video});
      }
      this.cleanup = () => {
        abort.abort();
        resize.disconnect();
        for (const {intersection, video} of films) {intersection.disconnect(); video.pause();}
      };
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
})();


